import { defineType } from 'sanity';

export default  defineType({
	name:   'navigationMenu',
	title:  'Navigation Menu',
	type:   'document',
	fields: [
		{
			name:       'title',
			type:       'localizedText',
			title:      'Title',
			validation: Rule => Rule.required(),
		},
		{
			name:  'menu',
			type:  'array',
			title: 'Menu Items',
			of:    [ { type: 'navigationMenuItem' } ],
		},
	],
	preview: { prepare: () => ({ title: 'Navigation Menu' }) },
});